// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AccountSummaryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /contas/contas/account_summary/{conta_id}
 *
 * Fetches account summary. No body required — conta_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Contas_AccountSummaryInput {}

registerContract('Contas_AccountSummaryInput', {})
